<template>
  <v-btn
    class="ma-3 btn-border"
    color="white"
    :width="width"
    :height="height"
    :disabled="isDisabled"
    link
    :to="to"
    v-if="visible"
  >
    <span>
      <img :src="iconSrc" :alt="altText" class="image-style" />
      <div style="font-size: 16px" class="mt-2">{{ label }}</div>
    </span>
  </v-btn>
</template>

<script>
export default {
  props: {
    iconSrc: String,
    label: String,
    to: Object,
    width: {
      type: String,
      default: '190px',
    },
    height: {
      type: String,
      default: '190px',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    altText: {
      type: String,
      default: 'icon',
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-border {
  border-radius: 20px !important;
}

.image-style {
  display: block;
  margin: auto;
  max-width: 60px;
  max-height: 60px;
}
</style>
